import PaymentsDetails from 'features/v2a/receiver/screens/PaymentsDetails/PaymentsDetails';
import React from 'react';

export default function Page() {
  return <PaymentsDetails />;
}
